import React, { Component } from 'react';
import Firebase from 'firebase/app';
import { NavLink } from 'react-router-dom';
import { FirestoreCollection } from 'react-firestore';
import FireflySubscription from '../misc/FireflySubscription';
import Error from '../misc/Error';

class AddAllToListButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saved: false,
      isLoading: false,
      isOpen: false,
      emailIndex: [],
      journalistIndex: [],
      podcastIndex: [],
      broadcasterIndex: [],
      influencerIndex: [],
      dataType: this.props.dataType,
    };
    this._isMounted = false;
    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    this._isMounted = true;
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    this._isMounted = false;
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };

  toggleDropdown = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  };

  formatUpdatedAt = (value) => {
    if (!value) return '';
    const date = typeof value.toDate === 'function' ? value.toDate() : new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  async addJournalistsToList(key, profiles, plan) {
    try {
      console.log("Adding journalists");
      console.log("addJournalistsToList", { listId: key, count: profiles.length });

      var docRef = Firebase.firestore().collection("lists").doc(key);
      await docRef.get().then(doc => {
        //fetch email Index and set state as such
        this.setState({
          journalistIndex: doc.data().journalistIndex || [],
          isOpen: false,
        })
      })
      await docRef.collection("entries").get().then(snap => {
        if (snap.size > 12000) {
          return alert("You've reached limit. Please contact support!");
        }
        if (snap.size < 201 || plan  === 3 || plan === 30 || plan  === 4 || plan === 40 || plan  === 5 || plan === 50 || plan  === 6 || plan === 60 || plan  === 7 || plan === 70) {
          let journalistIndex = this.state.journalistIndex;

          Promise.all(profiles.map((profile, index) => {

            let objectID = profile.objectID;
            this.setState({ isLoading: true });

            if (objectID && journalistIndex.includes(objectID)) {
              return;
            } else {
              profile.addedOn = Firebase.firestore.Timestamp.now();
              profile.dataType = "journalist";
              profile["counter"] = snap.size + index + 1;
              if (profile.secondary_email && profile.email === "") {
                profile.email = profile.secondary_email;
              };
              journalistIndex.push(objectID);
              return docRef.collection("entries")
                .add(profile)
                .catch( error => {
                  alert(`Whoops, couldn't add to list: ${error.message}`)
                })
            };
          }))
          .then(() => {
            docRef.update({
              updatedOn: Firebase.firestore.Timestamp.now(),
              journalistIndex
            });
            this.setState({ isLoading: false, saved: true });
            setTimeout(() => {
              this.setState({ saved: false });
            }, 2000);
          });
        }
        else
          return alert("This list has reached your limit of 200 entries!");
      });
    } catch (error) {
      console.error("addJournalistsToList failed", error);
      alert(`Whoops, couldn't add to list: ${error.message}`)
    }
  }

  async addPodcastsToList(key, profiles, plan) {
    try {
      console.log("Adding podcasts");
      console.log("addPodcastsToList", { listId: key, count: profiles.length });

      var docRef = Firebase.firestore().collection("lists").doc(key);
      await docRef.get().then(doc => {
        //fetch email Index and set state as such
        this.setState({
          podcastIndex: doc.data().podcastIndex || [],
          isOpen: false,
        })
      })
      await docRef.collection("entries").get().then(snap => {
        if (snap.size > 12000) {
          return alert("You've reached limit. Please contact support!");
        }
        if (snap.size < 201 || plan  === 3 || plan === 30 || plan  === 4 || plan === 40 || plan  === 5 || plan === 50 || plan  === 6 || plan === 60 || plan  === 7 || plan === 70) {
          let podcastIndex = this.state.podcastIndex;

          Promise.all(profiles.map((profile, index) => {

            let objectID = profile.objectID;
            this.setState({ isLoading: true });

            if (objectID && podcastIndex.includes(objectID)) {
              return;
            } else {
              profile.addedOn = Firebase.firestore.Timestamp.now();
              profile.dataType = "podcast";
              profile.name = profile.title;
              profile["counter"] = snap.size + index + 1;

              podcastIndex.push(objectID);
              return docRef.collection("entries")
                .add(profile)
                .catch( error => {
                  alert(`Whoops, couldn't add to list: ${error.message}`)
                })
            };
          }))
          .then(() => {
            docRef.update({
              updatedOn: Firebase.firestore.Timestamp.now(),
              podcastIndex
            });
            this.setState({ isLoading: false, saved: true });
            setTimeout(() => {
              this.setState({ saved: false });
            }, 2000);
          });
        }
        else
          return alert("This list has reached your limit of 200 entries!");
      });
    } catch (error) {
      console.error("addPodcastsToList failed", error);
      alert(`Whoops, couldn't add to list: ${error.message}`)
    }
  }

  async addBroadcastsToList(key, profiles, plan) {
    try {
      console.log("Adding broadcasters");
      console.log("addBroadcastsToList", { listId: key, count: profiles.length });

      var docRef = Firebase.firestore().collection("lists").doc(key);
      await docRef.get().then(doc => {
        //fetch email Index and set state as such
        this.setState({
          broadcasterIndex: doc.data().broadcasterIndex || [],
          isOpen: false,
        })
      })
      await docRef.collection("entries").get().then(snap => {
        if (snap.size > 12000) {
          return alert("You've reached limit. Please contact support!");
        }
        if (snap.size < 201 || plan  === 3 || plan === 30 || plan  === 4 || plan === 40 || plan  === 5 || plan === 50 || plan  === 6 || plan === 60 || plan  === 7 || plan === 70) {
          let broadcasterIndex = this.state.broadcasterIndex;

          Promise.all(profiles.map((profile, index) => {

            let objectID = profile.objectID;
            this.setState({ isLoading: true });

            if (objectID && broadcasterIndex.includes(objectID)) {
              return;
            } else {
              profile.addedOn = Firebase.firestore.Timestamp.now();
              profile.dataType = "broadcaster";
              profile["counter"] = snap.size + index + 1;
              if (profile.name !== undefined) {
                profile.name = profile.outlet;
              };

              broadcasterIndex.push(objectID);
              return docRef.collection("entries")
                .add(profile)
                .catch( error => {
                  alert(`Whoops, couldn't add to list: ${error.message}`)
                })
            };
          }))
          .then(() => {
            docRef.update({
              updatedOn: Firebase.firestore.Timestamp.now(),
              broadcasterIndex
            });
            this.setState({ isLoading: false, saved: true });
            setTimeout(() => {
              this.setState({ saved: false });
            }, 2000);
          });
        }
        else
          return alert("This list has reached your limit of 200 entries!");
      });
    } catch (error) {
      console.error("addBroadcastsToList failed", error);
      alert(`Whoops, couldn't add to list: ${error.message}`)
    }
  }
  async addInfluencersToList(key, profiles, plan) {
    try {
      console.log("Adding influencers");
      console.log("addInfluencersToList", { listId: key, count: profiles.length });

      var docRef = Firebase.firestore().collection("lists").doc(key);
      await docRef.get().then(doc => {
        //fetch email Index and set state as such
        this.setState({
          influencerIndex: doc.data().influencerIndex || [],
          isOpen: false,
        })
      })
      await docRef.collection("entries").get().then(snap => {
        if (snap.size > 12000) {
          return alert("You've reached limit. Please contact support!");
        }
        if (snap.size < 201 || plan  === 3 || plan === 30 || plan  === 4 || plan === 40 || plan  === 5 || plan === 50 || plan  === 6 || plan === 60 || plan  === 7 || plan === 70) {
          let influencerIndex = this.state.influencerIndex;

          Promise.all(profiles.map((profile, index) => {

            let objectID = profile.objectID;
            this.setState({ isLoading: true });

            if (objectID && influencerIndex.includes(objectID)) {
              return;
            } else {
              profile.addedOn = Firebase.firestore.Timestamp.now();
              profile.dataType = "influencer";
              profile["counter"] = snap.size + index + 1;

              influencerIndex.push(objectID);
              return docRef.collection("entries")
                .add(profile)
                .catch( error => {
                  alert(`Whoops, couldn't add to list: ${error.message}`)
                })
            };
          }))
          .then(() => {
            docRef.update({
              updatedOn: Firebase.firestore.Timestamp.now(),
              influencerIndex
            });
            this.setState({ isLoading: false, saved: true });
            setTimeout(() => {
              this.setState({ saved: false });
            }, 2000);
          });
        }
        else
          return alert("This list has reached your limit of 200 entries!");
      });
    } catch (error) {
      console.error("addInfluencersToList failed", error);
      alert(`Whoops, couldn't add to list: ${error.message}`)
    }
  }

  async addToList(key, profiles, plan) {
    console.log("Legacy function");
  }

  render() {
    const { dataType, isOpen } = this.state;
    return (
      <FireflySubscription>
        { ({ isLoading, error, auth, subscription }) => {
          if (isLoading) {
            return (
              <button className="inline-flex items-center gap-2 px-4 py-2.5 bg-blue-600 text-white text-sm font-semibold rounded-lg shadow-md">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                Save page
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
            )
          }
          if (error) {
            return <Error error={error} />
          }
          if (!auth) {
            return <span />
          }
          return (
            <FirestoreCollection
              path={`lists`}
              sort="createdOn:desc"
              filter={['createdBy', '==', auth.uid]}
            >
              { ({error, isLoading, data}) => {
                if (error) {
                  return <Error error={error} />
                }
                if (isLoading) {
                  return  (
                    <button className="inline-flex items-center gap-2 px-4 py-2.5 bg-blue-600 text-white text-sm font-semibold rounded-lg shadow-md">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                      Save page
                      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                  )
                }
                if (!isLoading && data.length === 0) {
                  return <span />
                }
                return (
                  <div ref={this.dropdownRef} className="relative">
                    {this.state.isLoading ? (
                      <button className="inline-flex items-center gap-2 px-4 py-2.5 bg-amber-500 text-white text-sm font-semibold rounded-lg shadow-md">
                        <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                        </svg>
                        Processing...
                      </button>
                    ) : this.state.saved ? (
                      <button className="inline-flex items-center gap-2 px-4 py-2.5 bg-green-600 text-white text-sm font-semibold rounded-lg shadow-md">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        Saved!
                      </button>
                    ) : (
                      <>
                        <button
                          onClick={this.toggleDropdown}
                          className="inline-flex items-center gap-2 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-150"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                          </svg>
                          Save page
                          <svg className={`w-3 h-3 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </button>

                        {/* Dropdown Menu */}
                        {isOpen && (
                          <div className="absolute right-0 mt-2 w-64 bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden z-50">
                          <div className="max-h-64 overflow-y-auto divide-y divide-gray-100">
                              {data.map((list, index) => (
                                ((subscription.plan === 2 || subscription === 20) && list.csvUpload) ? (
                                  <NavLink
                                    key={list.id}
                                    to="/pricing"
                                    className="flex items-center gap-3 px-4 py-3 text-sm text-gray-600 hover:bg-gray-50 transition-colors"
                                  >
                                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                                    </svg>
                                    <span className="flex-1 truncate">{list.name}</span>
                                    <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                    </svg>
                                  </NavLink>
                                ) : (
                                  <button
                                    key={index}
                                    onClick={() => {
                                      dataType === "journalist" ?
                                      this.addJournalistsToList(list.id, this.props.profiles, subscription.plan) : dataType === "podcast" ?
                                      this.addPodcastsToList(list.id, this.props.profiles, subscription.plan) : dataType === "broadcaster" ?
                                      this.addBroadcastsToList(list.id, this.props.profiles, subscription.plan) : dataType === "influencer" ?
                                      this.addInfluencersToList(list.id, this.props.profiles, subscription.plan) : this.addToList(list.id, this.props.profiles, subscription.plan)
                                    }}
                                    className="flex items-center gap-3 w-full px-4 py-3 text-sm text-gray-600 hover:bg-blue-50 hover:text-blue-700 transition-colors text-left"
                                  >
                                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                                    </svg>
                                    <span className="flex-1 min-w-0">
                                      <span className="block truncate">{list.name || 'Untitled list'}</span>
                                      {list.updatedOn ? (
                                        <span className="block text-xs text-gray-400 truncate">
                                          Updated {this.formatUpdatedAt(list.updatedOn)}
                                        </span>
                                      ) : null}
                                    </span>
                                  </button>
                                )
                              ))}
                            </div>
                            <div className="border-t border-gray-200 p-2">
                              <NavLink
                                to="/lists/new"
                                className="flex items-center gap-2 w-full px-3 py-2 text-sm font-medium text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                </svg>
                                New list
                              </NavLink>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )
              }}
            </FirestoreCollection>
          )
        }}
      </FireflySubscription>
    )
  }
}
export default AddAllToListButton;
